import { render, staticRenderFns } from "./metadata-project.vue?vue&type=template&id=34519996&scoped=true&"
import script from "./metadata-project.vue?vue&type=script&lang=js&"
export * from "./metadata-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34519996",
  null
  
)

export default component.exports